export default function (formattedAmount: string): string {
  return formattedAmount.replace(/[0-9]/g, "X");
}
